
import React, {FC} from 'react';
import {FullPageSpinner} from 'components/FullPageSpinner';
import ProvisionalPage from 'components/ProvisionalPage';
import {ReloadError} from 'components/ReloadError';
import LocationSlots from 'templates/booking/Content/LocationSlots';

import {Confirm} from './Confirm';
import {useBooking} from './useBooking';
import {usePartner} from './usePartners';

import * as styles from './styles.module.scss';

type PartnerBookingProps = {
	partnerId: string
	partnerName: string
}

const PartnerBooking: FC<PartnerBookingProps> = ({partnerId, partnerName}) => {
	const partner = usePartner(partnerId);
	const {date, time, state, refresh, setters} = useBooking(partner.data.slug);

	const location = state.locations?.[0];
	if (!location) {
		return <FullPageSpinner />;
	} else if (!partner.data.slug || partner.data.partner.length === 0) {
		return <ReloadError fullPage />;
	}

	return (
		<ProvisionalPage>
			<div className={styles.wrapper}>
				<div className={styles.title}>
				Reserve your BodySpec scan at {partnerName}
				</div>
				<LocationSlots
					location={location}
					initial={date?.date}
					loading={state.loading}
					callbacks={{
						onDate: setters.setDate,
						onTime: setters.setTime,
					}}
				/>
				{time && (
					<Confirm
						partner={partner.data.partner[0].data.key}
						time={time}
						onHide={() => {
							setters.setTime(undefined);
							refresh();
						}}
					/>
				)}
			</div>
		</ProvisionalPage>
	);
};

export default PartnerBooking;
